import { SubscriptionPlan } from './TenantSubscriptionPlan';

/**
 * Static plan id → commercial name mapping (TDD-3433). Used for analytics so the
 * `commercial_name` property is stable regardless of UI translations (which differ:
 * e.g. `starter` displays as "Starter" but its commercial name is "Essential").
 *
 * The back ships the same value as `commercialName` in the 403 / menu-visibility; this
 * is the front-side fallback for surfaces that don't have that data (e.g. sidebar clicks
 * which open the modal without an API call).
 */
export const PLAN_COMMERCIAL_NAME: Record<SubscriptionPlan, string> = {
    free: 'Starter',
    starter: 'Essential',
    pro: 'Pro (LEGACY)',
    enterprise: 'Expert',
    growth: 'Growth (LEGACY)',
    'combo-free': 'Business Starter',
    'combo-starter': 'Combo Starter (LEGACY)',
    'combo-essential': 'Business Essential',
    'combo-pro': 'Combo Pro (LEGACY)',
    'combo-enterprise': 'Business Expert',
};

export const getPlanCommercialName = (planId: string | null | undefined): string | null => {
    if (!planId) return null;
    return PLAN_COMMERCIAL_NAME[planId as SubscriptionPlan] ?? null;
};
